<template>
  <td v-if="statusGeral !== null">
    <table class="app-menu-usuario" ref="divBotao">
      <tr>
        <!-- SETA O BOTÃO DO NOME DO USUARIO -->
        <td class="usuario">
          <router-link tag="a" :to="link" :href="link" target="_parent" class="btn btn-primary" :style="$store.state.token.dep_plus === true ? 'height: 48px;' : ''">
            <!-- SETA O ICONE -->
            <svg class="fa fa-user" aria-hidden="true"></svg>

            <!-- SETA O NOME DO USUARIO -->
            <span v-html="$store.state.token.conta"></span>
            
            <div v-if="$store.state.token.dep_plus === true" style="text-align: right; margin: 0px; height: 0px; line-height: 5px;">
              <br/>
              {{ $store.state.licenca.cnpj }}
            </div>
          </router-link>
        </td>

        <!-- SETA  O BOTÃO DA FLECHINHA -->
        <td class="icone">
          <RF-Button :style="$store.state.token.dep_plus === true ? 'height: 48px;' : ''"
          :cpntId='"app-menu-usuario-bt"'
          :cpntStatus='statusGeral' 
          :cpntClass='"btn btn-primary dropdown-toggle"'
          @onClickButton='() => { appMenuUsuarioMostrarDados({ type: "click" }) }'>
          <template slot="conteudo">
            <span v-if="statusGeral === ''">
              <svg class="fa fa-caret-down"></svg>
            </span>
          </template>
          </RF-Button>
        </td>
      </tr>
    </table>

    <!-- SETA O CONTEUDO DA TELA -->
    <RF-Dialog-Referencia :cpntPositionFixed="true" v-if="mostrar === true" :cpntElement="$refs.divBotao" :cpntOnFechar="appMenuUsuarioMostrarDados" :cpntAlignX="'bottom-end'">
      <div class="app-menu-usuario-conteudo" :style="'width: ' + ($store.state.tamanhoTela.width - 26 - 2)">
        <table class="logada">
          <tr>
            <!-- APRESENTA A LOGOTIPO -->
            <td class="logo">
              <img ref="logo" :src="$store.state.logotipo" :alt="$store.state.licenca.rSocial" @load="appMenuUsuarioCarregarTamanhoImagens('logo')"/>
            </td>

            <td>
              <!-- APRESENTA A CONTA LOGADA -->
              <div class="conta" v-html="$store.state.token.conta"></div>

              <!-- APRESENTA O EMAIL DO USUARIO -->
              <div class="email" v-html="$store.state.usuario.email"></div>

              <!-- APRESENTA O BOTÃO MEU USUARIO -->
              <div class="botao">
                <router-link tag="a" :to="link" :href="link" target="_parent" class="btn btn-primary btn-sm">
                  Meu Usuário
                </router-link>

                <RF-Button style="margin-left: 10px;"
                :cpntId='"web-menu-conta-sair-conta"'
                :cpntStatus='""' 
                :cpntTipo='"icone-texto"' 
                :cpntIcone="{ tipo: 'sair' }"
                :cpntTexto='"Sair"' 
                :cpntClass='[ "btn", "btn-default", "btn-sm" ]'

                @onClickButton='appMenuUsuarioAbrirConta("SAIR_CONTA")'
              ></RF-Button>
              </div>
            </td>
          </tr>
        </table>

        <div class="contas app-menu-fundo-destaque" v-if="Object.keys($store.state.contas).length >= 2" :style="'max-height: ' + ($store.state.tamanhoTela.height * 0.60)">
          <table>
            <template v-for='(conta, indexC, indexV) in $store.state.contas'>
              <template  v-if='$store.state.token.conta !== conta.conta && conta.salvar === true'>
                <tr :key="indexC + '-tr-1'" @click='appMenuUsuarioAbrirConta(indexC)'>
                  <td rowspan="5" class="logo">
                    <img :ref="'logo-' + indexV" :src='conta.logotipo' @load="appMenuUsuarioCarregarTamanhoImagens('logo-' + indexV)"/>
                  </td>
                </tr>

                <tr :key="indexC + '-tr-2'" @click='appMenuUsuarioAbrirConta(indexC)'>
                  <td class="conta" v-html='conta.conta'></td>
                </tr>

                <tr :key="indexC + '-tr-3'" @click='appMenuUsuarioAbrirConta(indexC)'>
                  <td class="nome">
                    <span v-if="[ '', null, undefined ].indexOf(conta.licenca) === -1 && [ '', null, undefined ].indexOf(conta.licenca.rSocial) === -1" v-html='conta.licenca.rSocial'></span>
                  </td>
                </tr>

                <tr :key="indexC + '-tr-4'" @click='appMenuUsuarioAbrirConta(indexC)'>
                  <td class="nome">
                    <span v-if="[ '', null, undefined ].indexOf(conta.licenca) === -1 && [ '', null, undefined ].indexOf(conta.licenca.cnpj) === -1" v-html='conta.licenca.cnpj'></span>
                  </td>
                </tr>

                <tr :key="indexC + '-tr-5'" @click='appMenuUsuarioAbrirConta(indexC)'>
                  <td class="desconectado">
                    <span v-if='conta.conectado === false' v-html='"Desconectado"'></span>
                  </td>
                </tr>

                <tr :key="indexC + '-tr-6'" @click='appMenuUsuarioAbrirConta(indexC)' class="separador">
                  <td colspan="2"></td>
                </tr>
              </template>
            </template>
          </table>
        </div>

        <div class="entrar app-menu-fundo-destaque">
          <RF-Button
            :cpntId='"web-menu-conta-entrar"'
            :cpntStatus='""' 
            :cpntTexto='"Entrar com outra conta"' 
            :cpntClass='[ "btn", "btn-primary", "btn-sm" ]'

            @onClickButton='appMenuUsuarioAbrirConta("")'
          ></RF-Button>

          <RF-Button
            :cpntId='"web-menu-conta-sair-geral"'
            :cpntStatus='""' 
            :cpntTipo='"icone-texto"' 
            :cpntIcone="{ tipo: 'sair' }"
            :cpntTexto='"Sair de todas as contas"' 
            :cpntClass='[ "btn", "btn-default", "btn-sm" ]'

            @onClickButton='appMenuUsuarioAbrirConta("SAIR_CONTAS")'
          ></RF-Button>
        </div>
      </div>
    </RF-Dialog-Referencia>
  </td>
</template>

<style scoped>
  .app-menu-usuario {
    display: inline-block;
    text-align: left;
  }
    .app-menu-usuario {
      display: inline-block;
    }
      .app-menu-usuario > tr > td.usuario > a,
      .app-menu-usuario > tr > td.icone > button {
        display: list-item !important;
        list-style-type: none;
        height: 30px;
        padding: 5px 10px;
        color: #fff;
      }
      .app-menu-usuario > tr > td.usuario > a,
      .app-menu-usuario > tr > td.icone > button {
        background-color: #2b646a !important;
        border-color: #277880 !important;
      }
      .app-menu-usuario > tr > td.usuario > a:focus,
      .app-menu-usuario > tr > td.icone > button:focus {
        box-shadow: none;
      }
      .app-menu-usuario > tr > td.usuario > a:hover,
      .app-menu-usuario > tr > td.icone > button:hover {
        background-color: #267880 !important;
        border-color: #267880 !important;
      }
      .app-menu-usuario > tr > td.usuario > a {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
        .app-menu-usuario > tr > td.usuario > a > svg {
          font-size: 13px;
          vertical-align: -1px;
          margin-right: 4px;
        }
      .app-menu-usuario > tr > td.icone > button {
        width: 30px;
        border-left: none;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
.app-menu-usuario-conteudo {
  max-width: 450px;
}
  .app-menu-usuario-conteudo > .logada {
    width: 100%;
  }
    .app-menu-usuario-conteudo > .logada > tr > td.logo {
      min-width: 140px;
      max-width: 200px;
      padding-top: 5px;
      text-align: center;
    }
      .app-menu-usuario-conteudo > .logada > tr > td.logo > img {
        max-width: 130px;
      }
    .app-menu-usuario-conteudo > .logada > tr > td > .conta {
      font-size: var(--font-base-soma-15);
      line-height: 21px;
      color: var(--color-base-01);
      font-weight: 700;
    }
    .app-menu-usuario-conteudo > .logada > tr > td > .email {
      font-size: var(--font-base-soma-12);
      line-height: 16px;
      color: #0648cd;
    }
    .app-menu-usuario-conteudo > .logada > tr > td > .botao {
      padding: 10px 0px;
    }
      .app-menu-usuario-conteudo > .logada > tr > td > .botao > a {
        border: 1px solid #ccc;
        padding: 3px 15px;
        background-color: #209daa;
        color: #fff;
        text-shadow: none;
        font-size: var(--font-base-soma-14);
      }

  .app-menu-fundo-destaque {
    width: calc(100% + 10px);
    margin-left: -5px;
    border-top: 1px solid #e1e1e8;
    /* border-bottom: 1px solid #e1e1e8; */
    background-color: #f5f5f5;
  }
  .app-menu-usuario-conteudo > .contas {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .app-menu-usuario-conteudo > .contas > table {
    width: 100%;
  }
    .app-menu-usuario-conteudo > .contas > table > tr > td {
      cursor: pointer;
    }
    .app-menu-usuario-conteudo > .contas > table > tr > td.logo {
      width: 170px;
      text-align: center;
    }
      .app-menu-usuario-conteudo > .contas > table > tr > td.logo > img {
        max-width: 120px;
      }

    .app-menu-usuario-conteudo > .contas > table > tr > td.conta {
      font-size: var(--font-base-soma-14);
      line-height: 18px;
      color: var(--color-base-01);
      padding-top: 10px;
      padding-bottom: 0;
    }
    .app-menu-usuario-conteudo > .contas > table > tr > td.nome {
      border-right: 1px solid #e1e1e8;
      font-size: var(--font-base-soma-12);
      line-height: 16px;
      color: #0648cd;
    }
    .app-menu-usuario-conteudo > .contas > table > tr > td.desconectado {
      font-size: var(--font-base-soma-12);
      line-height: 15px;
      color: var(--color-base-01);
      font-style: italic;
      height: 20px;
    }
    .app-menu-usuario-conteudo > .contas > table > tr.separador > td {
      border-bottom: 1px solid #e1e1e8;
    }

  .app-menu-usuario-conteudo > .entrar {
    margin-bottom: -10px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    text-align: center;
  }
    .app-menu-usuario-conteudo > .entrar > button {
      font-size: var(--font-base-soma-13);
      padding: 5px 30px;
      /* margin: 0px 20px; */
    }
    .app-menu-usuario-conteudo > .entrar > button:first-child {
      margin: 15px 15px 15px 0;
      color: #fff;
      border: 1px solid #3079ed;
      background-color: #326dce;
      background-image: -webkit-linear-gradient(top,#326dce,#4787ed);
    }

@media only screen and (max-width: 700px) {
  .app-menu-usuario > tr > td.usuario {
    display: none;
  }
  .app-menu-usuario > tr > td.icone > button {
    border-left: 1px solid #267880 !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}
</style>

<style>
  .app-menu-usuario > tr > td.icone > button > div.rf-status{
    margin-left: -4px;
  }
  .app-menu-usuario > tr > td.icone > button > span > svg,
  .app-menu-usuario > tr > td.icone > button > div > svg {
    color: #fff;
  }
</style>

<script>
  export default {
    components: {
      'RF-Dialog-Referencia': () => import('@/components/rf-geral/dialog/RF-Dialog-Referencia.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: null,
        link: '',
        mostrar: false
      }
    },
    mounted: function () {
      this.appMenuUsuarioIniciar()
    },
    methods: {
      appMenuUsuarioIniciar: function () {
        // SETA O STATUS DA TELA
        this.appMenuUsuarioSetarStatusGeral(null)

        // SETA O LINK QUE DEVE SER REDIRECIONADO
        this.link = ('/' + this.$store.state.token.cts + '/cs/' + window.btoa(JSON.stringify({ url: (process.env.VUE_APP_URL_CS + '/app/usuarios/usu_ger.php?cts=' + this.$store.state.token.cts), post: {}, target: '_self' })))

        // SETA O STATUS DA TELA
        this.appMenuUsuarioSetarStatusGeral('')
      },
      appMenuUsuarioSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appMenuUsuarioMostrarDados: function (event) {
        if (event.type === 'click') {
          // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS
          if (this.mostrar === false) {
            this.appMenuUsuarioCarregarDados()
          } else {
            // SETA SE DEVE OU NÃO MOSTRAR O REGISTRO
            this.mostrar = !this.mostrar

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }
      },
      appMenuUsuarioCarregarTamanhoImagens: function (chave) {
        // PEGA O ELEMENTO QUE SERÁ TRABALHADO
        var element = this.$refs[chave].length === 1 ? this.$refs[chave][0] : this.$refs[chave]

        // INICIA OS TAMANHOS
        var width = 120
        var height = 54

        // VERIFICA SE TEM QUE TER ALGUM TAMANHO 
        switch (chave) {
          case 'logo':
            width = 130
            height = 59
            break
        }

        // IMPORTA A FUNÇÃO
        const FUN_REDIMENCIONAR_IMAGEM = require('@/assets/js/Funcoes-Gerais.js').FUN_REDIMENCIONAR_IMAGEM

        // CHAMA A FUNÇÃO PARA REDIMENCIONAR IMAGEM PROPORCIONAMENTE
        FUN_REDIMENCIONAR_IMAGEM(element, width, height)
      },
      appMenuUsuarioCarregarDados: function () {
        // SETA O STATUS DE CARREGANDO NO BOTÃO
        this.appMenuUsuarioSetarStatusGeral('carregando')

        // IMPORTA A FUNÇÃO PARA INICIAR AS VERIFICAÇÕES DA SESÃO
        const SESSAO_MONTAR_CONTAS = require('@/assets/js/Sessao.js').SESSAO_MONTAR_CONTAS

        // VERIFICA AS CONTAS EXISTENTES
        SESSAO_MONTAR_CONTAS().then(() => {
          // SETA SE DEVE OU NÃO MOSTRAR O REGISTRO
          this.mostrar = true

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA O STATUS DE CARREGANDO NO BOTÃO
          this.appMenuUsuarioSetarStatusGeral('')
        })
      },
      appMenuUsuarioAbrirConta: function (conta) {
        // CHAMA A FUNÇÃO PARA FECHAR A TELA DOS CARTÕES
        this.appMenuUsuarioMostrarDados({ type: "click" })

        // VERIFICA O QUE DEVE SER FEITO
        switch (conta) {
          case 'SAIR_CONTA':
            // APRESENTA A MASCARA DE CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

            // REDIRECIONA PARA A ROTA DE SAIDA
            this.$router.push({ name: 'pag_logout_conta' })
            break

          case 'SAIR_CONTAS':
            // APRESENTA A MASCARA DE CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

            // REDIRECIONA PARA A ROTA DE SAIDA
            this.$router.push({ name: 'pag_logout', params: { cts: 'todas' } })
            break
          
          case '':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'pag_ace', params: {} }).href, '_blank')
            break

          default:
            // PEGA OS DADOS DA CONTA SOLICITADA
            var params = this.$store.state.contas[conta]

            // APRESENTA A MASCARA DE CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

            // VERIFICA SE A CONTA ESTÁ CONECTADA
            if ([ '', null, undefined ].indexOf(params.cts) === -1 && params.conectado === true) {
              // IMPORTA A FUNÇÃO PARA INICIAR AS VERIFICAÇÕES DA SESÃO
              const UPDATE_SESSION_CS = require('@/assets/js/Sessao.js').UPDATE_SESSION_CS

              // REALIZA O CARREGAMENTO DA SESSÃO DO USUARIO
              UPDATE_SESSION_CS('cs-entrar', params.cts, params.token, conta, () =>{
                // ABRE A CONTA SOLICITADA NA PAGINA INICIAL
                this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'pag_inicial', params: { cts: params.cts } }).href, '_blank')

                // OCULTA A MASCARA DE CARREGANDO
                this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
              })
            } else {
              // ABRE A PAGINA SOLICIADA
              this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'pag_login', params: { login: conta } }).href, '_blank')

              // OCULTA A MASCARA DE CARREGANDO
              this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
            }
            break
        }
      }
    }
  }
</script>
